import { render, staticRenderFns } from "./OfferInvestorsForm.vue?vue&type=template&id=bfa672aa&scoped=true"
import script from "./OfferInvestorsForm.vue?vue&type=script&lang=js"
export * from "./OfferInvestorsForm.vue?vue&type=script&lang=js"
import style0 from "./OfferInvestorsForm.vue?vue&type=style&index=0&id=bfa672aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa672aa",
  null
  
)

export default component.exports